<template>
  <div class="popup-wrapper" v-if="visible">
    <Form ref="authFormRef" :initial-values="authInitValues">
      <div class="popup">
        <img
          src="@/assets/imgs/common/close.png"
          alt="닫기"
          class="close"
          @click="clickCloseModal(false)"
        />
        <p class="title-text">본인 인증하기</p>
        <div class="name-wrapper">
          <Field
            id="userName"
            name="userName"
            label="이름"
            rules="required"
            v-slot="{ field }"
          >
            <label for="userName">이름</label>
            <input
              type="text"
              v-bind="field"
              name="userName"
              id="userName"
              placeholder="이름을 입력해주세요."
            />
          </Field>
        </div>
        <div class="select-wrapper">
          <ul class="tab-title">
            <li
              :class="authType === 'mobile' ? 'on' : ''"
              @click="authType = 'mobile'"
            >
              휴대전화번호
            </li>
            <li
              :class="authType === 'email' ? 'on' : ''"
              @click="authType = 'email'"
            >
              이메일
            </li>
          </ul>
          <div class="tab-sub">
            <Field
              ref="countryCodeRef"
              type="radio"
              id="countryCode"
              name="countryCode"
              label="이름"
              rules="required"
              v-slot="{ field }"
            >
              <ul class="radio-wrapper" v-show="authType === 'mobile'">
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    name="countryCode1"
                    id="countryCode1"
                    value="inner"
                    v-bind="field"
                    v-model="authInitValues.countryCode"
                    :checked="authInitValues.countryCode === 'inner'"
                    @change="onChangeCountryCode(authInitValues.countryCode)"
                  />
                  <label class="pointer" for="countryCode1">국내</label>
                </li>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    name="countryCode1"
                    id="countryCode2"
                    value="outer"
                    v-bind="field"
                    v-model="authInitValues.countryCode"
                    :checked="authInitValues.countryCode === 'outer'"
                    @change="
                      onChangeCountryCode(authInitValues.countryCode, $event)
                    "
                  />
                  <label class="pointer" for="countryCode2">해외</label>
                </li>
              </ul>
            </Field>
            <ul class="input-wrapper">
              <li class="select-country-wrapper">
                <div
                  class="country-box"
                  id="country-cur"
                  v-show="
                    authInitValues.countryCode === 'outer' &&
                    authType === 'mobile'
                  "
                >
                  <div
                    :class="
                      selectCountryText === '국가 선택' ? 'item2' : 'item1'
                    "
                  >
                    <div
                      class="flag-svg"
                      v-show="selectCountryText !== '국가 선택'"
                    >
                      <flag :iso="selectCountryCode" />
                    </div>
                    <div
                      v-show="selectCountryText === '국가 선택'"
                      :class="
                        selectCountryText === '국가 선택'
                          ? 'select-country'
                          : ''
                      "
                    >
                      {{ selectCountryText }}
                    </div>
                  </div>
                  <div
                    :class="
                      selectCountryText === '국가 선택' ? 'item1' : 'item2'
                    "
                  >
                    <div v-show="selectCountryText !== '국가 선택'">
                      {{ selectCountryText }}
                    </div>
                  </div>
                  <div class="item3">
                    <img
                      class="arrow-img"
                      src="../assets/imgs/spac/arrow.svg"
                      alt="국기선택"
                    />
                  </div>
                </div>
                <ul
                  class="country-list h-200px"
                  id="country-list"
                  v-show="authInitValues.countryCode === 'outer'"
                >
                  <li
                    class="dp-inblock w-100per"
                    v-for="countryItem in compCountryList"
                    :key="'country' + countryItem.code1"
                  >
                    <div class="country-item" @click="selectItem(countryItem)">
                      <div class="country-wrap">
                        <div
                          :class="
                            countryItem.code1 ? 'country-flag' : 'country-text'
                          "
                        >
                          <div class="flag-svg" v-show="countryItem.code1">
                            <flag :iso="countryItem.code1" />
                          </div>
                          <div v-show="!countryItem.code1">국가 선택</div>
                        </div>
                        <div
                          :class="
                            countryItem.code1 ? 'country-text' : 'country-flag'
                          "
                        >
                          <div v-show="countryItem.code1">
                            {{ countryItem.countrykname }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
              <li class="get-code-wrapper">
                <Field
                  id="mobile"
                  name="mobile"
                  ref="authInputRef"
                  :label="authType === 'mobile' ? '휴대전화번호' : '이메일'"
                  :rules="
                    authType === 'mobile'
                      ? selectCountryCode === 'kr'
                        ? 'required|mobilePhone'
                        : 'required'
                      : 'required|emailCheck'
                  "
                  v-slot="{ field }"
                >
                  <input
                    type="text"
                    :placeholder="
                      authType === 'mobile'
                        ? selectCountryCode === 'kr'
                          ? '000-0000-0000'
                          : ''
                        : 'carrot@global.com'
                    "
                    v-bind="field"
                    @input="inputTel"
                    @keyup.enter="onSubmit"
                  />
                </Field>
                <p @click="onSubmit">인증번호 받기</p>
              </li>
              <li class="write-code-wrapper">
                <input
                  v-show="showAuthNumber"
                  v-model="authInitValues.authNumber"
                  type="text"
                  placeholder="인증번호를 입력하세요."
                  @keyup.enter="onAuthComplete"
                />
                <ErrorMessage class="warning" name="mobile"></ErrorMessage>
              </li>
            </ul>
          </div>
          <p class="ok" v-show="showAuthNumber" @click="onAuthComplete">
            인증 완료
          </p>
        </div>
      </div>
    </Form>
  </div>
</template>
<script>
import { computed, nextTick, onMounted, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import _ from "lodash";
import { Form } from "vee-validate";
import {
  authMobile,
  authEmail,
  authMobileCheck,
  authEmailCheck,
  getProxyList,
} from "@/api/integratedapi/index";
export default {
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["closeModal"],
  setup(props, cotext) {
    let eleBtn = null;
    let eleList = null;
    const selectCountryCode = ref("kr");
    const selectCountryText = ref("");
    const store = useStore();
    const authFormRef = ref(null);
    const countryCodeRef = ref(null);
    const authInputRef = ref(null);
    const authType = ref("mobile");
    const showAuthNumber = ref(false);

    const authInitValues = {
      userName: "",
      mobile: "",
      countryCode: "inner",
      authNumber: "",
      email: "",
    };

    const clickCloseModal = (isSuccessAuth = false) => {
      cotext.emit("closeModal", isSuccessAuth);
    };

    const onSubmit = async () => {
      const { validate } = authFormRef.value;
      const { valid, errors } = await validate();

      if (!valid) {
        const key = Object.keys(errors)[0];
        alert(errors[key]);
        return false;
      }

      try {
        let isSuccess = false;
        if (authType.value === "mobile") {
          const { data } = await getMobileAuth();
          const { success } = data;
          isSuccess = success;
        } else {
          const { data } = await getEmailAuth();
          const { success } = data;
          isSuccess = success;
        }

        showAuthNumber.value = isSuccess;

        if (showAuthNumber.value) {
          alert(`인증번호가 전송되었습니다.`);
        }
      } catch (error) {
        alert(error);
        console.error("onSubmit error : ", error);
      }
    };

    const inputTel = (eve) => {
      if (authType.value === "mobile" && selectCountryCode.value === "kr") {
        const { target } = eve;
        const formatted = target.value
          .replace(/[^0-9]/g, "")
          .replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);

        // vee-validate의 setFieldValue를 사용하여 값 설정
        if (authFormRef.value) {
          authFormRef.value.setFieldValue("mobile", formatted);
        }
      }
    };

    const getMobileAuth = async () => {
      const find = store.getters.getCountryIsoList.find(
        (country) => country.code1 === selectCountryCode.value,
      );

      try {
        const formValues = authFormRef.value.values;
        return await authMobile({
          countryCode: find ? find["phone"] : "",
          mobile: formValues.mobile,
          userName: formValues.userName,
        });
      } catch (error) {
        console.error("getMobileAuth error : ", error);
      }
    };

    const getEmailAuth = async () => {
      try {
        const formValues = authFormRef.value.values;
        return await authEmail({
          email: formValues.mobile,
          userName: formValues.userName,
        });
      } catch (error) {
        console.error("getEmailAuth error : ", error);

        return error;
      }
    };

    const getMobileCheck = async () => {
      try {
        const find = store.getters.getCountryIsoList.find(
          (country) => country.code1 === selectCountryCode.value,
        );
        const formValues = authFormRef.value.values;

        return await authMobileCheck({
          authNumber: authInitValues.authNumber,
          countryCode: Number(find["phone"]),
          mobile: formValues.mobile,
          userName: formValues.userName,
        });
      } catch (error) {
        console.error("getMobileCheck error : ", error);
      }
    };

    const getEmailCheck = async () => {
      try {
        const formValues = authFormRef.value.values;
        return await authEmailCheck({
          authNumber: authInitValues.authNumber,
          email: formValues.mobile,
          userName: formValues.userName,
        });
      } catch (error) {
        console.error("getEmailCheck error : ", error);
        return error;
      }
    };

    const onChangeCountryCode = (value) => {
      if (value === "inner") {
        selectCountryCode.value = "kr"; //국내
      } else {
        selectCountryCode.value = "";
        selectCountryText.value = "국가 선택";
      }

      clearValue();
    };

    const clearValue = () => {
      //값 초기화
      if (authFormRef.value) {
        authFormRef.value.resetForm();
      }
      authInitValues.authNumber = "";
      showAuthNumber.value = false;
    };

    const compCountryList = computed(() => {
      const copy = _.cloneDeep(store.getters.getCountryIsoList);
      copy.unshift({
        countrykname: "국가 선택",
        countryename: "-select-",
        code1: "",
        code2: "",
      });
      return copy;
    });
    const setEventAddListsener = () => {
      nextTick(() => {
        selectCountryCode.value = "kr";
        selectCountryText.value = "국가 선택";
        eleBtn = document.querySelector("#country-cur");
        eleList = document.querySelector("#country-list");
        if (eleBtn && eleList) {
          eleBtn.addEventListener("click", () => {
            if (eleList.classList.contains("active")) {
              eleList.classList.remove("active");
            } else {
              eleList.classList.add("active");
            }
          });
        }
      });
    };
    const selectItem = (value) => {
      eleList.classList.remove("active");
      const { countrykname, phone, code1 } = value;

      selectCountryCode.value = code1;
      selectCountryText.value = countrykname;
    };

    const onAuthComplete = async () => {
      if (!authInitValues.authNumber) {
        alert("인증번호를 확인해주세요");
        return false;
      }

      try {
        let isSuccess = false;
        let storeData = {};
        if (authType.value === "mobile") {
          const { data } = await getMobileCheck();
          const { success, data: respData } = data;
          storeData = respData;
          isSuccess = success;
        } else {
          const { data } = await getEmailCheck();
          const { success, data: respData } = data;
          storeData = respData;
          isSuccess = success;
        }

        if (isSuccess) {
          alert("인증되었습니다.");
          clickCloseModal(false);

          try {
            store.commit("setAccessToken", storeData.accessToken);
            const loginType = authType.value;
            storeData.userInfo["code"] = store.getters.getCompanyInfo["code"];
            storeData.userInfo["loginType"] = loginType;
            store.commit("setUserInfo", storeData.userInfo);

            // 대리인 리스트 조회 (비동기 처리)
            const proxyParams = {
              sugangCode: store.getters.getCompanyInfo.code,
            };
            if (storeData.userInfo.mobile) {
              proxyParams.proxyMobile = storeData.userInfo.mobile;
            }
            if (storeData.userInfo.email) {
              proxyParams.proxyEmail = storeData.userInfo.email;
            }
            getProxyList(proxyParams)
              .then(({ data: proxyRes }) => {
                store.commit("setProxyList", proxyRes.data || []);
              })
              .catch((error) => {
                console.error("대리인 리스트 조회 실패:", error);
                store.commit("setProxyList", []);
              });
          } catch (e) {
            console.error("인증 후 처리 실패:", e);
          }
        } else {
          alert("인증에 실패하였습니다.");
          store.commit("setAccessToken", "");
          store.commit("setUserInfo", {});
        }
      } catch (error) {
        alert("인증에 실패하였습니다.");
        store.commit("setAccessToken", "");
        store.commit("setUserInfo", {});
        console.error("onAuthComplete error : ", error);
      }
    };

    watch(
      () => props.visible,
      (cur) => {
        if (cur) {
          //값 초기화
          setEventAddListsener();
          clearValue();
        }
      },
    );

    watch(
      () => authType.value,
      () => {
        clearValue();
      },
    );

    watch(
      () => authType.value,
      () => {
        const { reset } = authInputRef.value;
        reset();
      },
    );
    onMounted(() => {
      setEventAddListsener();
    });
    return {
      authFormRef,
      countryCodeRef,
      showAuthNumber,
      authType,
      authInitValues,
      selectCountryCode,
      selectCountryText,
      clickCloseModal,
      compCountryList,
      selectItem,
      onSubmit,
      onChangeCountryCode,
      onAuthComplete,
      inputTel,
      authInputRef,
    };
  },
  components: { Form },
};
</script>
<style lang="scss" scoped>
.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: $black, $alpha: 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .popup {
    display: flex;
    flex-direction: column;
    background-color: $white;
    border-radius: 14px;
    padding: 20px 42px 47px 42px;
    width: 500px;
    max-width: 500px;
    position: relative;

    .title-text {
      font-size: 30px;
      font-weight: $bold;
      text-align: center;
      margin-bottom: 40px;
      margin-top: 30px;
    }

    .close {
      width: 19px;
      align-self: flex-end;
      cursor: pointer;
      position: absolute;
      right: 19px;
      top: 19px;
    }

    input:-webkit-autofill {
      -webkit-box-shadow: 0 0 0px 1000px rgba($color: $gray-dde0e4, $alpha: 0.5)
        inset;
    }

    .name-wrapper {
      display: flex;
      flex-direction: column;
      gap: 9px 0;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid rgba($color: $black, $alpha: 0.07);

      label {
        font-weight: $bold;
      }

      input {
        font-size: 16px;
        color: $black;
        padding: 15px;
        background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
        border-radius: 8px;

        &::placeholder {
          color: #949494;
        }
      }
    }

    .select-wrapper {
      .tab-title {
        display: flex;
        justify-content: space-between;
        gap: 0 12px;
        margin-bottom: 17px;

        li {
          width: 50%;
          font-size: 14px;
          font-weight: $bold;
          color: #959595;
          text-align: center;
          border: 1px solid #959595;
          border-radius: 8px;
          padding: 13px 0;
          cursor: pointer;

          &.on {
            color: $blue;
            border: 1px solid $blue;
          }
        }
      }

      .tab-sub {
        margin-bottom: 37px;

        .radio-wrapper {
          display: flex;
          gap: 0 17px;
          margin-bottom: 7px;

          li {
            display: flex;
            align-items: center;
            gap: 0 5px;

            input {
              width: 12px;
              height: 12px;
            }

            label {
              font-size: 14px;
              font-weight: $bold;
            }
          }
        }

        .input-wrapper {
          li {
            display: flex;

            input {
              flex-grow: 1;
              font-size: 16px;
              color: $black;
              padding: 15px;
              background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
              border-radius: 8px;

              &::placeholder {
                color: $gray-949494;
              }
            }

            .country-box {
              flex-grow: 1;
              font-size: 16px;
              color: $black;
              padding: 12px 15px;
              background-color: rgba($color: $gray-dde0e4, $alpha: 0.5);
              border-radius: 8px;
              display: flex;
              cursor: pointer;
            }

            .item1 {
              width: 9%;
            }

            .item2 {
              width: 85%;
            }

            .item3 {
              width: 6%;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .select-country {
              color: $gray-949494;
            }

            .arrow-img {
              width: 13px;
              height: 9px;
              cursor: pointer;
              margin-top: 4px;
            }
          }

          .select-country-wrapper {
            gap: 0 12px;
            margin-bottom: 8px;
            position: relative;
            // height: 48px;

            .country-list {
              position: absolute;
              overflow-y: scroll;
              top: 58px;
              left: 0;
              width: 100%;
              transform: scaleY(0);
              background-color: $white;
              border: solid 1px #e7e7e7;
              border-radius: 8px;

              box-shadow: 3.6px 1.8px 40px 0 rgba(0, 0, 0, 0.13);

              &.active {
                transform: scaleY(1);
              }
            }

            .country-list::-webkit-scrollbar {
              width: 3px;
            }

            .country-list::-webkit-scrollbar-thumb {
              background-color: $black;
            }
            .country-list::-webkit-scrollbar-track {
              background-color: $gray-cdcdcd;
            }

            .country-wrap {
              display: flex;
              padding: 10px 10px 0 10px;
            }

            .country-item:hover {
              background-color: $gray-f6f7f8;
            }

            .country-flag {
              width: 10%;
              border-bottom: 1px solid #e7e7e7;
              padding-bottom: 10px;
            }

            .country-text {
              width: 90%;
              border-bottom: 1px solid #e7e7e7;
              padding-bottom: 10px;
            }
          }

          .get-code-wrapper {
            justify-content: space-between;
            gap: 0 12px;
            margin-bottom: 8px;

            p {
              font-size: 14px;
              color: $white;
              text-align: center;
              line-height: 48px;
              padding: 0 17px;
              background-color: $black;
              border-radius: 8px;
              flex: none;
              cursor: pointer;
            }
          }

          .write-code-wrapper {
            flex-direction: column;

            .warning {
              font-size: 14px;
              color: $red;
              margin-top: 10px;
            }
          }
        }

        .flag-svg {
          font-size: 16px;
        }
      }

      .ok {
        max-width: 162px;
        margin: 0 auto;
        font-weight: $bold;
        color: $white;
        text-align: center;
        background-color: $blue;
        padding: 16px 0;
        border-radius: 8px;
        cursor: pointer;
      }
    }
  }
}
</style>
